<template>
    <v-row>
        <v-col cols="12" sm="6" md="3">
            <span class="d-block mb-2">{{
                $t('holidaysView.showFromYear')
            }}</span>
            <v-select
                v-model="year"
                :items="yearOptions"
                :label="$t('holidaysView.selectYear')"
                solo
            />
        </v-col>
        <v-col cols="12">
            <v-data-table
                class="elevation-2"
                :headers="headers"
                :items="holidays"
                :items-per-page="25"
                :footer-props="{
                    itemsPerPageOptions: [10, 25, 50]
                }"
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc"
            >
                <template v-slot:item.date="{ item }">
                    {{ item.date | dateFormatFromSettings }}
                </template>
                <template v-slot:item.repeat="{ item }">
                    {{ item.repeat ? $t('holidaysView.repeated') : '' }}
                </template>
                <template v-slot:item.action="{ item }">
                    <div class="d-flex">
                        <v-icon
                            v-if="visibilityConfig.actions.edit"
                            class="mr-3"
                            size="20"
                            @click="$emit('edit', item)"
                        >
                            mdi-pencil
                        </v-icon>
                        <v-icon
                            v-if="visibilityConfig.actions.delete"
                            size="20"
                            @click="$emit('delete', item)"
                        >
                            mdi-delete
                        </v-icon>
                    </div>
                </template>
            </v-data-table>
        </v-col>
    </v-row>
</template>

<script>
import dayjs from 'dayjs';
import { mapActions } from 'vuex';

export default {
    name: 'holidayList',

    props: {
        visibilityConfig: {
            type: Object,
            required: false,
            default: () => ({
                actions: {
                    edit: true,
                    delete: true
                },
                excludeHeaders: null
            })
        },
        holidays: {
            type: Array,
            required: true
        }
    },

    data() {
        return {
            year: dayjs().year(),
            sortBy: 'date',
            sortDesc: false,
            headers: [
                {
                    text: this.$t('holidaysView.headers.date'),
                    value: 'date'
                },
                {
                    text: this.$t('holidaysView.headers.name'),
                    value: 'name'
                },
                {
                    text: this.$t('holidaysView.headers.repeat'),
                    value: 'repeat'
                },
                {
                    text: this.$t('holidaysView.headers.action'),
                    value: 'action'
                }
            ]
        };
    },

    computed: {
        yearOptions() {
            const fromYear = parseInt(
                dayjs()
                    .subtract(3, 'years')
                    .year()
            );
            const yearList = [];

            for (let i = 0; i < 14; i++) {
                yearList.push(fromYear + i);
            }

            return yearList;
        }
    },

    async created() {
        try {
            await this.fetchHolidaysForYear({ year: dayjs().year() });

            if (this.visibilityConfig.excludeHeaders) {
                this.headers = this.headers.filter(
                    header =>
                        !this.visibilityConfig.excludeHeaders.includes(
                            header.value
                        )
                );
            }
        } catch (error) {
            this.$notify({
                group: 'notify',
                type: 'error',
                title: this.$t('holidaysView.title'),
                text: this.$t('holidaysView.fetchError')
            });

            console.error(error);
        }
    },

    watch: {
        async year(year) {
            await this.fetchHolidaysForYear({ year });
        }
    },

    methods: {
        ...mapActions({
            fetchHolidaysForYear: 'holidays/fetchForYear'
        })
    }
};
</script>
